export default "__VITE_ASSET__571b0f70__"